var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-auto"},[_c('div',{staticClass:"mt-4"},[_c('b-pagination',{attrs:{"total-rows":_vm.rows,"per-page":_vm.perPage,"align":"center"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }